export type ReaderType = 'theory-book' | 'work-book' | 'theory-work-book';
export const MIN_READER_PAGE_COUNT = 60;
export const MAX_READER_PAGE_COUNT = 640;

export enum ReaderStatuses {
  Draft = 'draft',
  Generating = 'generating',
  Generated = 'generated',
  Processing = 'processing',
  Processed = 'processed',
  Ready = 'ready',
  Failed = 'failed',
}

export type ReaderStatus = `${ReaderStatuses}`;

export interface Reader {
  id: string;
  externalId: string | null;
  arrangementCode: string;
  contentIdentifier: string;
  title: string;
  description: string | null;
  methodCode: string;
  readerType: ReaderType;
  status: ReaderStatus;
  pageCount: number | null;
  schoolName: string | null;
  s3Path: string | null;
  signedUrl: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  storeUrl: string | null;
}

export const readerTypes: Array<ReaderType> = [
  'theory-work-book',
  'theory-book',
  'work-book',
];

export const readerUnfinishedStates: Array<ReaderStatus> = [
  ReaderStatuses.Draft,
  ReaderStatuses.Generating,
];

export const readyForOrderStates: Array<ReaderStatus> = [
  ReaderStatuses.Processed,
  ReaderStatuses.Ready,
];

export const readerEditableState: Array<ReaderStatus> = [
  ReaderStatuses.Draft,
  ReaderStatuses.Generated,
  ReaderStatuses.Generating,
];
